/* ==========================================================================
   נירוסטה מונטנה — runtime לגרסת Shopify.
   אותה חוויה כמו באתר, מול נתוני החנות החיים: סל אמיתי (AJAX API),
   וחיפוש/סינון מתצוגת JSON של הקטגוריות (?view=nm-index).
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  window.NM = window.NM || {};
  var S = NM.shop || {};

  var nf = new Intl.NumberFormat('he-IL', { maximumFractionDigits: 0 });
  function money(v) { return '₪' + nf.format(Math.round(v)); }
  NM.money = money;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  NM.esc = esc;

  function store(key, val) {
    try {
      if (val === undefined) { var r = localStorage.getItem(key); return r ? JSON.parse(r) : null; }
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { /* אחסון חסום */ }
    return null;
  }

  var PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  /* ---------- Toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    $('span', toastEl).textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  NM.toast = toast;

  /* ---------- נעילת גלילה ---------- */
  var lockCount = 0, savedY = 0;
  function lockScroll() {
    if (lockCount++) return;
    var sb = window.innerWidth - document.documentElement.clientWidth;
    savedY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedY + 'px';
    document.body.style.width = '100%';
    if (sb > 0) document.body.style.paddingInlineEnd = sb + 'px';
  }
  function unlockScroll() {
    if (--lockCount > 0) return;
    lockCount = 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.paddingInlineEnd = '';
    window.scrollTo(0, savedY);
  }

  /* ---------- שכבות ---------- */
  var scrim = $('#scrim');
  var openLayers = [];
  function openLayer(el, onClose) {
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    if (scrim) scrim.classList.add('is-on');
    lockScroll();
    openLayers.push({ el: el, onClose: onClose });
    var f = el.querySelector('input:not([type=hidden]), button, a[href]');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 260);
  }
  function closeTop() {
    var L = openLayers.pop();
    if (!L) return;
    L.el.classList.remove('is-open');
    L.el.setAttribute('aria-hidden', 'true');
    if (!openLayers.length && scrim) scrim.classList.remove('is-on');
    unlockScroll();
    if (L.onClose) L.onClose();
  }
  NM.openLayer = openLayer;
  NM.closeTop = closeTop;
  if (scrim) scrim.addEventListener('click', closeTop);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayers.length) { e.preventDefault(); closeTop(); }
  });

  /* ---------- Header ---------- */
  var hdr = $('.hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mega menu ---------- */
  (function () {
    var btn = $('#megaBtn'), mega = $('#mega'), t;
    if (!btn || !mega) return;
    function open() { clearTimeout(t); mega.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { mega.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    function delayedClose() { t = setTimeout(close, 180); }
    btn.addEventListener('mouseenter', open);
    btn.addEventListener('focus', open);
    btn.addEventListener('click', function (e) { e.preventDefault(); mega.classList.contains('is-open') ? close() : open(); });
    btn.addEventListener('mouseleave', delayedClose);
    mega.addEventListener('mouseenter', function () { clearTimeout(t); });
    mega.addEventListener('mouseleave', delayedClose);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!mega.contains(e.target) && !btn.contains(e.target)) close(); });
  })();

  /* ---------- ניווט מובייל ---------- */
  (function () {
    var btn = $('#navBtn'), dr = $('#navDrawer');
    if (!btn || !dr) return;
    btn.addEventListener('click', function () { openLayer(dr); });
    $$('.mnav__l1 > button', dr).forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
    $$('[data-close]', dr).forEach(function (x) { x.addEventListener('click', closeTop); });
  })();

  /* ======================================================================
     סל — Shopify AJAX Cart API
     ====================================================================== */
  function api(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var cartState = null;
  function fetchCart() { return api(S.cartUrl + '.js').then(function (c) { cartState = c; paintCount(); return c; }); }
  function paintCount() {
    var n = cartState ? cartState.item_count : (S.cartCount || 0);
    $$('#cartCount').forEach(function (el) { el.textContent = n; el.classList.toggle('is-on', n > 0); });
  }
  function imgW(url, w) {
    if (!url) return S.placeholder || '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function addToCart(variantId, qty, name) {
    return api(S.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: +variantId, quantity: Math.max(1, qty || 1) }] }) })
      .then(fetchCart)
      .then(function () { toast('נוסף לסל · ' + (name || '')); paintCart(); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'לא ניתן להוסיף לסל כרגע'); });
  }
  NM.addToCart = addToCart;

  function setQty(key, q) {
    return api(S.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
      .then(function (c) { cartState = c; paintCount(); paintCart(); })
      .catch(function () { toast('העדכון לא נשמר, נסו שוב'); });
  }

  var cartBody = $('#cartBody'), cartFoot = $('#cartFoot');
  function paintCart() {
    if (!cartBody || !cartState) return;
    var items = cartState.items || [];
    if (!items.length) {
      cartBody.innerHTML =
        '<div class="empty"><div class="h3">הסל ריק</div>' +
        '<p>אפשר להתחיל מהקטלוג, או לשלוח לנו מידה לייצור בהתאמה אישית.</p>' +
        '<a class="btn" href="' + esc(S.collectionsUrl) + '">לקטלוג המוצרים</a></div>';
      if (cartFoot) cartFoot.hidden = true;
      var bx = $('#cartXsell'); if (bx) bx.hidden = true;
      return;
    }
    if (cartFoot) cartFoot.hidden = false;
    cartBody.innerHTML = items.map(function (i) {
      return '<div class="citem" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '">' +
        '<a href="' + esc(i.url) + '"><img src="' + esc(imgW(i.image, 164)) + '" alt="" width="82" height="82" loading="lazy"></a>' +
        '<div><a class="citem__n" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
        '<div class="citem__r">' +
        '<div class="qty qty--sm"><button type="button" data-act="dec" aria-label="הפחתת כמות">–</button>' +
        '<input type="number" min="1" value="' + i.quantity + '" aria-label="כמות"><button type="button" data-act="inc" aria-label="הוספת כמות">+</button></div>' +
        '<span class="citem__p">' + money(i.final_line_price / 100) + '</span></div>' +
        '<button class="citem__rm" type="button" data-act="rm">הסרה</button>' +
        '</div></div>';
    }).join('');
    var tot = $('#cartTotal');
    if (tot) tot.textContent = money(cartState.total_price / 100);
    paintXsell(items);
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var row = b.closest('.citem'); var key = row.getAttribute('data-key'); var q = +row.getAttribute('data-q');
      var act = b.getAttribute('data-act');
      if (act === 'inc') setQty(key, q + 1);
      else if (act === 'dec') setQty(key, q - 1);
      else if (act === 'rm') setQty(key, 0);
    });
    cartBody.addEventListener('change', function (e) {
      if (e.target.tagName !== 'INPUT') return;
      var row = e.target.closest('.citem');
      setQty(row.getAttribute('data-key'), parseInt(e.target.value, 10) || 1);
    });
  }

  var cartDrawer = $('#cartDrawer');
  function openCart() {
    if (!cartDrawer) return;
    openLayer(cartDrawer);
    if (cartState) paintCart();
    fetchCart().then(paintCart);
  }
  NM.openCart = openCart;
  $$('#cartBtn').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-close-cart]').forEach(function (x) { x.addEventListener('click', closeTop); });

  /* מכירה משלימה — המלצות של Shopify למוצר האחרון שנוסף */
  function paintXsell(items) {
    var box = $('#cartXsell');
    if (!box || !S.recoUrl || !items.length) { if (box) box.hidden = true; return; }
    var inCart = {};
    items.forEach(function (i) { inCart[i.product_id] = 1; });
    fetch(S.recoUrl + '.json?product_id=' + items[0].product_id + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var pick = (d.products || []).filter(function (p) { return !inCart[p.id] && p.featured_image && p.available; }).slice(0, 2);
        if (pick.length < 2) { box.hidden = true; return; }
        box.hidden = false;
        box.innerHTML = '<div class="tag">לקוחות מוסיפים גם</div>' + pick.map(function (p) {
          return '<div class="cxsell__row"><img src="' + esc(imgW(p.featured_image, 108)) + '" alt="" width="54" height="54" loading="lazy">' +
            '<a href="' + esc(p.url) + '"><b>' + esc(p.title) + '</b></a>' +
            '<button class="pcard__add" type="button" data-add="' + p.variants[0].id + '" data-name="' + esc(p.title) + '" aria-label="הוספה לסל">' + PLUS + '</button></div>';
        }).join('');
      })
      .catch(function () { box.hidden = true; });
  }

  /* הוספה לסל מכל מקום בדף */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    var qtyInput = $('#pdpQty');
    var qty = b.hasAttribute('data-add-qty') && qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    b.classList.add('is-done');
    addToCart(b.getAttribute('data-add'), qty, b.getAttribute('data-name')).then(function () {
      setTimeout(function () { b.classList.remove('is-done'); }, 1200);
    });
  });

  paintCount();

  /* ---------- בקרת כמות בעמוד מוצר ---------- */
  $$('.qty').forEach(function (q) {
    if (q.closest('#cartBody')) return;
    var input = $('input', q); if (!input) return;
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.preventDefault();
      var v = parseInt(input.value, 10) || 1;
      var act = b.getAttribute('data-act');
      if (act === 'inc') input.value = v + 1;
      else if (act === 'dec') input.value = Math.max(1, v - 1);
    });
  });

  /* ---------- חשיפה בגלילה ---------- */
  (function () {
    var els = $$('.rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '140px 0px -6% 0px', threshold: 0.01 });
    els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); else io.observe(el); });
    window.addEventListener('beforeprint', function () { els.forEach(function (e) { e.classList.add('is-in'); }); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  })();

  /* ---------- וידאו בהירו ---------- */
  (function () {
    var v = $('#heroVid');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = navigator.connection || {};
    if (c.saveData) return;
    if (c.effectiveType && /^(slow-2g|2g|3g)$/.test(c.effectiveType)) return;
    var small = window.matchMedia('(max-width: 900px)').matches;
    var canWebm = !small && v.canPlayType && v.canPlayType('video/webm; codecs="vp9"') === 'probably';
    var src = small ? v.getAttribute('data-src-sm') : (canWebm ? v.getAttribute('data-src-webm') : v.getAttribute('data-src'));
    if (!src) return;
    function start() {
      v.addEventListener('playing', function () { v.classList.add('is-ready'); }, { once: true });
      v.preload = 'auto';
      v.src = src;
      var p = v.play();
      if (p && p.catch) p.catch(function () { });
    }
    if (document.readyState === 'complete') setTimeout(start, 200);
    else window.addEventListener('load', function () { setTimeout(start, 200); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (!v.src) return;
        if (en[0].isIntersecting) { var q = v.play(); if (q && q.catch) q.catch(function () { }); } else v.pause();
      }, { threshold: 0.05 }).observe(v);
    }
  })();

  /* ---------- Parallax ---------- */
  (function () {
    var hero = $('.hero'); if (!hero) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var grid = $('.hero__grid', hero), media = $('.hero__media', hero);
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - .5) * 2;
      ty = ((e.clientY - r.top) / r.height - .5) * 2;
      if (!raf) raf = requestAnimationFrame(tick);
    });
    hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(tick); });
    function tick() {
      cx += (tx - cx) * .07; cy += (ty - cy) * .07;
      if (grid) grid.style.transform = 'translate3d(' + (cx * -8).toFixed(2) + 'px,' + (cy * -6).toFixed(2) + 'px,0)';
      if (media) media.style.transform = 'scale(1.05) translate3d(' + (cx * 7).toFixed(2) + 'px,' + (cy * 6).toFixed(2) + 'px,0)';
      raf = (Math.abs(tx - cx) > .001 || Math.abs(ty - cy) > .001) ? requestAnimationFrame(tick) : 0;
    }
  })();

  /* ======================================================================
     נתוני קטלוג חיים — תצוגת JSON של קטגוריה, כל העמודים
     ====================================================================== */
  function loadCollection(url) {
    var out = [];
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    function page(n) {
      return fetch(url + sep + 'view=nm-index&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d = JSON.parse(t);
          out = out.concat(d.products || []);
          return d.page < d.pages ? page(n + 1) : out;
        });
    }
    return page(1);
  }
  NM.loadCollection = loadCollection;

  var indexPromise = null;
  function setIndex(list) {
    NM.index = list;
    NM.byId = {};
    list.forEach(function (p) { NM.byId[String(p.id)] = p; });
    return { products: list };
  }
  function loadIndex() {
    if (indexPromise) return indexPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem('nm.idx.v2') || 'null');
      if (cached && Date.now() - cached.at < 15 * 60e3) { indexPromise = Promise.resolve(setIndex(cached.list)); return indexPromise; }
    } catch (e) { }
    indexPromise = loadCollection(S.allUrl)
      .then(function (list) {
        try { sessionStorage.setItem('nm.idx.v2', JSON.stringify({ at: Date.now(), list: list })); } catch (e) { }
        return setIndex(list);
      })
      .catch(function () { return setIndex([]); });
    return indexPromise;
  }
  NM.loadIndex = loadIndex;

  function normalize(s) {
    return String(s).toLowerCase().replace(/["'״׳]/g, '').replace(/[֑-ׇ]/g, '').replace(/\s+/g, ' ').trim();
  }
  function parseDimQuery(q) {
    var m = normalize(q).match(/(\d{2,3})\s*[x×*\/]\s*(\d{2,3})(?:\s*[x×*\/]\s*(\d{2,3}))?/);
    if (!m) return null;
    return { w: +m[1], d: +m[2], h: m[3] ? +m[3] : null };
  }
  NM.parseDimQuery = parseDimQuery;

  function scoreProduct(p, terms, dq) {
    var hay = p._h || (p._h = normalize(p.n + ' ' + (p.c || '') + ' ' + (p.b || '')));
    var s = 0;
    if (dq) {
      if (p.w && p.d) {
        var dw = Math.abs(p.w - dq.w), dd = Math.abs(p.d - dq.d);
        if (dw <= 2 && dd <= 2) s += 140;
        else if (dw <= 12 && dd <= 12) s += 70 - (dw + dd);
        else if (dw <= 25 && dd <= 25) s += 26 - (dw + dd) / 3;
      }
      if (!terms.length) return s;
    }
    for (var i = 0; i < terms.length; i++) {
      var t = terms[i]; if (!t) continue;
      var idx = hay.indexOf(t);
      if (idx < 0) return -1;
      s += 12;
      if (idx === 0 || hay[idx - 1] === ' ') s += 8;
    }
    if (p.i) s += 4;
    return s;
  }
  function search(q, limit) {
    var dq = parseDimQuery(q);
    var cleaned = dq ? normalize(q).replace(/(\d{2,3})\s*[x×*\/]\s*(\d{2,3})(\s*[x×*\/]\s*(\d{2,3}))?/, ' ') : normalize(q);
    var terms = cleaned.split(' ').filter(function (t) { return t.length > 1; });
    if (!terms.length && !dq) return [];
    var out = [], arr = NM.index || [];
    for (var i = 0; i < arr.length; i++) { var sc = scoreProduct(arr[i], terms, dq); if (sc > 0) out.push({ p: arr[i], s: sc }); }
    out.sort(function (a, b) { return b.s - a.s; });
    return out.slice(0, limit || 8).map(function (o) { return o.p; });
  }
  NM.search = search;

  function dimHTML(p, cls) {
    if (p.w && p.d) return '<span class="' + cls + '">' + p.w + '<span class="dim__x">×</span>' + p.d + (p.hh ? '<span class="dim__x">×</span>' + p.hh : '') + '<span class="dim__u">CM</span></span>';
    if (p.z) return '<span class="' + cls + '">⌀ ' + p.z + '<span class="dim__u">CM</span></span>';
    return '';
  }

  NM.cardHTML = function (p) {
    return '<article class="pcard">' + (p.cp ? '<span class="badge badge--red">במבצע</span>' : '') +
      '<a class="pcard__media" href="' + esc(p.u) + '" aria-label="' + esc(p.n) + '">' +
      '<img class="is-primary" src="' + esc(p.i || S.placeholder) + '" alt="' + esc(p.n) + '" loading="lazy" decoding="async" width="420" height="420">' +
      '</a><div class="pcard__body">' +
      '<span class="pcard__cat">' + esc(p.c || '') + '</span>' +
      '<a class="pcard__name" href="' + esc(p.u) + '">' + esc(p.n) + '</a>' +
      dimHTML(p, 'dim pcard__dim') +
      '<div class="pcard__foot"><span>' + (p.cp ? '<span class="pcard__was">' + money(p.cp) + '</span>' : '') +
      '<span class="pcard__price">' + money(p.p) + '</span></span>' +
      '<button class="pcard__add" type="button" aria-label="הוספה לסל: ' + esc(p.n) + '" data-add="' + p.vid + '" data-name="' + esc(p.n) + '">' + PLUS + '</button>' +
      '</div></div></article>';
  };

  /* ---------- שכבת חיפוש ---------- */
  (function () {
    var ov = $('#search'), input = $('#searchInput'), res = $('#searchRes'), foot = $('#searchFoot');
    if (!ov || !input) return;
    $$('#searchBtn').forEach(function (b) {
      b.addEventListener('click', function () { openLayer(ov); loadIndex(); setTimeout(function () { input.focus(); }, 120); });
    });
    $$('[data-close-search]').forEach(function (x) { x.addEventListener('click', closeTop); });
    var t;
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { res.innerHTML = ''; if (foot) foot.hidden = true; return; }
      loadIndex().then(function () {
        var hits = search(q, 8);
        if (!hits.length) {
          res.innerHTML = '<div class="empty"><div class="h3">לא מצאנו מוצר במידה שחיפשתם</div>' +
            '<p>יש לנו ייצור בהתאמה אישית. שלחו לנו את המידה המדויקת ונחזור אליכם עם הצעה.</p>' +
            '<a class="btn btn--red" href="' + esc(S.pages + 'custom?ref=' + encodeURIComponent(q)) + '">שלחו לנו מידה לייצור</a></div>';
          if (foot) foot.hidden = true;
          return;
        }
        res.innerHTML = hits.map(function (p) {
          return '<a class="srch__row" href="' + esc(p.u) + '">' +
            '<img src="' + esc(p.i || S.placeholder) + '" alt="" width="76" height="76" loading="lazy">' +
            '<span><b>' + esc(p.n) + '</b><span class="meta"><span class="tag">' + esc(p.c || '') + '</span>' + dimHTML(p, 'dim') + '</span></span>' +
            '<span class="price">' + money(p.p) + '</span></a>';
        }).join('');
        if (foot) { foot.hidden = false; var a = $('a', foot); if (a) a.href = S.searchUrl + '?type=product&q=' + encodeURIComponent(q); }
      });
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 130); });
    $$('[data-q]', ov).forEach(function (c) {
      c.addEventListener('click', function () { input.value = c.getAttribute('data-q'); run(); input.focus(); });
    });
  })();

  /* ---------- עמוד תוצאות: חיפוש לפי מידה ---------- */
  (function () {
    var sg = $('#nmSearchGrid');
    if (!sg) return;
    var q = new URLSearchParams(location.search).get('q') || '';
    if (!parseDimQuery(q)) return;
    loadIndex().then(function () {
      var hits = search(q, 48);
      if (!hits.length) return;
      sg.innerHTML = hits.map(NM.cardHTML).join('');
      sg.hidden = false;
      var c = $('#nmSearchCount'); if (c) c.textContent = hits.length + ' תוצאות עבור "' + q + '" — כולל התאמות קרובות למידה';
      var e = $('#nmSearchEmpty'); if (e) e.hidden = true;
      var pg = $('.nm-pag'); if (pg) pg.hidden = true;
    });
  })();

  /* ---------- צפיתם לאחרונה ---------- */
  var RV_KEY = 'nm.recent.v1';
  NM.pushRecent = function (id) {
    id = String(id);
    var list = (store(RV_KEY) || []).filter(function (x) { return x !== id; });
    list.unshift(id);
    store(RV_KEY, list.slice(0, 12));
  };
  NM.renderRecent = function (mount, excludeId, max) {
    if (!mount) return;
    var sec = mount.closest('section');
    var ids = (store(RV_KEY) || []).filter(function (x) { return x !== String(excludeId); });
    if (!ids.length) { if (sec) sec.hidden = true; return; }
    loadIndex().then(function () {
      var items = ids.map(function (id) { return NM.byId[id]; }).filter(Boolean);
      // כפולה של 4 — שורות מלאות בלבד
      var n = Math.floor(Math.min(items.length, max || 4) / 4) * 4;
      if (!n) { if (sec) sec.hidden = true; return; }
      if (sec) sec.hidden = false;
      mount.innerHTML = items.slice(0, n).map(NM.cardHTML).join('');
    });
  };

  /* ---------- קישורי WhatsApp עם הקשר ---------- */
  $$('[data-wa]').forEach(function (a) {
    var base = a.getAttribute('href'), ctx = a.getAttribute('data-wa');
    if (ctx) a.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(ctx));
  });
})();
